import styled from "@emotion/styled";

export const StyleCheckbox = styled.input<any>`
  width: 15px;
  height: 15px;
  border-radius: 4px;
  padding: 0px;
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  ${(props) => props.styleInput}

  background-color: ${(props) =>
    props.checked ? props.theme.colors.primary : "transparent"};
  border-color: ${(props) =>
    props.checked
      ? props.theme.colors.primary
      : props.theme.colors.inputBorder};
`;

export const StyleCheckboxWrapper = styled.div<any>`
  display: flex;
  column-gap: 10px;
  align-items: center;
`;
